import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DateListener, zenSigleton } from '@zenlayer/util';

var recentlyVisitedClass = /*#__PURE__*/_createClass(function recentlyVisitedClass() {
  var _this = this;

  _classCallCheck(this, recentlyVisitedClass);

  _defineProperty(this, "dateListener", void 0);

  _defineProperty(this, "getAllData", function () {
    return _this.dateListener.getValue() || {};
  });

  _defineProperty(this, "setAllData", function (data) {
    _this.dateListener.setValue(data);
  });

  _defineProperty(this, "getKey", function () {
    var _zenSigleton$get;

    return "".concat((_zenSigleton$get = zenSigleton.get('user')) === null || _zenSigleton$get === void 0 ? void 0 : _zenSigleton$get.uid, "_").concat(zenSigleton.get('teamUid'));
  });

  _defineProperty(this, "getData", function () {
    var key = _this.getKey();

    return _this.getAllData()[key] || [];
  });

  _defineProperty(this, "setData", function (data) {
    var key = _this.getKey();

    _this.setAllData(_objectSpread(_objectSpread({}, _this.getAllData()), {}, _defineProperty({}, key, data.slice(0, 5))));
  });

  _defineProperty(this, "pushData", function (data) {
    var currentData = _this.getData();

    if (currentData.length === 0 || currentData[0].path !== data.path) {
      _this.setData([data].concat(_toConsumableArray(currentData.filter(function (i) {
        return i.path !== data.path;
      }))));
    }
  });

  _defineProperty(this, "useDataListener", function () {
    var key = _this.getKey();

    var allData = _this.dateListener.useValueListener() || {};
    return allData[key] || [];
  });

  this.dateListener = new DateListener('recentlyVisited', {
    setLocalStorage: true
  });
});

export var recentlyVisited = new recentlyVisitedClass();